import { render, staticRenderFns } from "./DialogShowFileInfo.vue?vue&type=template&id=1448c8a4&"
import script from "./DialogShowFileInfo.vue?vue&type=script&lang=js&"
export * from "./DialogShowFileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports